// innovators.js

initInnovatorsPage = function() {
  $howToEnter = $('#howToEnterNow');
  $('.tab', $howToEnter).on('click', function(evt) {
    console.log('howToEnter', evt, this);
    $('.tab, .tab-body', $howToEnter).removeClass('active');
    $('#howTo' + this.id, $howToEnter).addClass('active');
    $(this, $howToEnter).addClass('active');
  });
}

initInnovatorsSliders = function() {
  var $innovatorsSlider = $('.page-material-innovators #Gallery');

  if ($innovatorsSlider) {
    $innovatorsSlider.slick({
      dots: true,
      arrows: false,
      mobileFirst: true,
      adaptiveHeight: false,
      infinite: true,
      cssEase: 'ease-in-out',
      responsive: [
        {
          breakpoint: 768,
          settings: "unslick"
        }
      ]
    });
  }
}

initEntryImages = function() {
  var $articleSlider = $('.article-innovators #entryImages');
  var $relatedSlider = $('.article-innovators #relatedEntries .images');

  if ($articleSlider) {
    $articleSlider.slick({
      dots: false,
      arrows: true,
      prevArrow: '<button type="button" title="Previous" class="slick-prev"><span class="arrow-round-prev" aria-hidden="true">Previous</span></button>',
      nextArrow: '<button type="button" title="Next" class="slick-next"><span class="arrow-round-next" aria-hidden="true">Next</span></button>',
      mobileFirst: false,
      adaptiveHeight: false,
      infinite: true,
      cssEase: 'ease-in-out',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: true,
            arrows: false
          }
        }
      ]
    });
  }

  if ($relatedSlider) {
    $relatedSlider.slick({
      dots: true,
      arrows: false,
      mobileFirst: true,
      adaptiveHeight: false,
      infinite: true,
      cssEase: 'ease-in-out',
      responsive: [
        {
          breakpoint: 768,
          settings: 'unslick'
        }
      ]
    });
  }
}

initQV = function() {
  doQvClick = function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var url = $(e.target).closest('a').attr('href');
    console.log('doQvClick', e, url);
    $.ajax({
      url: url,
      success: function(data, status, xhr) {
        try {
          var qv = $('#quickview');
          qv.html(data);
        }
        catch (e) {
          console.log('error', e);
        }

        if (!qv.hasClass('vis')) {
          qv.css('top', $(window).scrollTop() + 'px').fadeIn(500).addClass('vis');
          $('#quickview-screen').fadeIn(250).addClass('vis');
        }
      },
      error: function(data, status, xhr) {
        console.log('there was an error loading this quickview.');
      }
    });
  }

  $('#Ingenuity a').on('click', doQvClick);
}

$( document ).ready(function() {
  initInnovatorsPage();
  initInnovatorsSliders();
  initEntryImages();
  initQV();
});
